import { render, staticRenderFns } from "./EgresoTable.vue?vue&type=template&id=5cf2404c&scoped=true"
import script from "./EgresoTable.vue?vue&type=script&lang=js"
export * from "./EgresoTable.vue?vue&type=script&lang=js"
import style0 from "./EgresoTable.vue?vue&type=style&index=0&id=5cf2404c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2404c",
  null
  
)

export default component.exports